export default __webpack_public_path__ + "static/swvl-1-730523afce7b9497b7914c1eef927986.webp";